export default __webpack_public_path__ + "static/media/br.465a8c3f.png";